import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Pagination } from "../models/pagination";
import { CategoriaRequest } from "../interfaces/categoriaRequest.model";
import * as global from "./global.service";
import { map } from "rxjs/operators";
import { objsToCamelCase, objToCamelCase } from "../helpers/object.helper";
import { Categoria } from "../models/categoria";

@Injectable({
  providedIn: "root",
})
export class CategoriaService {
  private static CATEGORIES_PATH: string = global.API_URL + `/api/categories`;
  private httpOptions: object;
  private httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    });
  }

  public index(categoriaRequest: CategoriaRequest): Observable<Pagination> {
    let httpParams: HttpParams = new HttpParams();

    if (categoriaRequest.getIdiomas()) {
      httpParams = httpParams.set(
        "idiomas",
        String(categoriaRequest.getIdiomas())
      );
    }

    if (categoriaRequest.getSubcategorias()) {
      httpParams = httpParams.set(
        "subcategorias",
        String(categoriaRequest.getSubcategorias())
      );
    }

    if (categoriaRequest.getSubcategoriasIdiomas()) {
      httpParams = httpParams.set(
        "subcategoriasIdiomas",
        String(categoriaRequest.getSubcategoriasIdiomas())
      );
    }

    if (categoriaRequest.getPerPage()) {
      httpParams = httpParams.set(
        "perPage",
        String(categoriaRequest.getPerPage())
      );
    }

    if (categoriaRequest.getOrderBy())
      httpParams = httpParams.set("orderBy", categoriaRequest.getOrderBy());

    if (categoriaRequest.getSortBy())
      httpParams = httpParams.set("sortBy", categoriaRequest.getSortBy());

    this.httpOptions = {
      headers: this.httpHeaders,
      params: httpParams,
    };

    return this.http
      .get<Pagination>(CategoriaService.CATEGORIES_PATH, this.httpOptions)
      .pipe(
        map((response: any) => {
          return objToCamelCase<Pagination>(response);
        })
      );
  }

  public create(categorie: Categoria): Observable<Categoria> {
    const httpParams: HttpParams = new HttpParams();
    this.httpOptions = {
      headers: this.httpHeaders,
      params: httpParams,
    };

    return this.http
      .post<Categoria>(
        CategoriaService.CATEGORIES_PATH,
        categorie,
        this.httpOptions
      )
      .pipe(
        map((response: any) => {
          return objToCamelCase<Categoria>(response);
        })
      );
  }

  public update(categorie: Categoria) {
    const httpParams: HttpParams = new HttpParams();
    this.httpOptions = {
      headers: this.httpHeaders,
      params: httpParams,
    };

    return this.http
      .put<Categoria>(
        CategoriaService.CATEGORIES_PATH + "/" + categorie.id,
        categorie,
        this.httpOptions
      )
      .pipe(
        map((response: any) => {
          return objsToCamelCase(response);
        })
      );
  }

  public delete(categorie: Categoria) {
    this.httpOptions = {
      headers: this.httpHeaders,
      params: {},
    };

    return this.http
      .delete<any>(
        global.API_URL + "/api/categories/" + categorie.id,
        this.httpOptions
      )
      .pipe(
        map((response: any) => {
          return objsToCamelCase(response);
        })
      );
  }
}
